import {styled} from '@customink/pigment-react/lib/themeCustomink';

const ProductCardContainer = styled('article', {
  shouldForwardProp: (prop) => prop !== 'isMobile'
})(({isMobile}) => ({
  ...(!isMobile && {
    '&:hover': {
      backgroundColor: 'white',
      boxShadow:
        '0px 0px 0px 1px rgba(0, 0, 0, 0.06),0px 8px 16px -4px rgba(0, 0, 0, 0.15)',
      margin: '-0.75rem',
      padding: '0.75rem',
      zIndex: 1
    }
  }),
  alignItems: 'flex-start',
  backgroundColor: 'transparent',
  borderRadius: '0.5rem',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: isMobile ? 'row' : 'column',
  gap: isMobile ? '0.75rem' : '0.5rem',
  margin: '-0.375rem',
  padding: '0.375rem',
  position: 'relative',
  transitionDuration: '150ms',
  WebkitTapHighlightColor: 'transparent'
}));

export default ProductCardContainer;
